module.exports = __webpack_public_path__ + "img/appBanner4.f8cc0a66.jpg";